import styled from 'styled-components';
import { ThemeMode } from '../../global-state/themeContext';
import { IconWithText } from '../../stories/molecules';
import { muiTheme } from '../../theme';
import { getSpacing } from '../../utils';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  gap: ${({ theme: { spacing } }) => spacing(6)};
  padding: ${({ theme: { spacing } }) => getSpacing([6, 0, 10], spacing)};
`;

const getColor = (isDisabled: boolean, palette: ThemeMode) => {
  if (isDisabled) {
    return palette === 'dark'
      ? { bgColor: muiTheme.color.borderGrayDark, iconColor: muiTheme.color.inActiveGray }
      : { bgColor: muiTheme.color.inActiveGray, iconColor: muiTheme.color.textGray };
  }
  return palette === 'dark'
    ? {
        bgColor: muiTheme.color.white,
        iconColor: muiTheme.color.primary,
      }
    : {
        bgColor: muiTheme.color.primary,
        iconColor: muiTheme.color.white,
      };
};

export const StyledIconWithText = styled(IconWithText)<{ isDisabled: boolean }>`
  border-radius: ${({ theme: { spacing } }) => spacing(1)};
  background-color: ${({ theme: { palette }, isDisabled }) => getColor(isDisabled, palette.mode).bgColor};
  cursor: ${({ isDisabled }) => isDisabled && 'not-allowed'};
  & > div {
    color: ${({ theme: { palette }, isDisabled }) => getColor(isDisabled, palette.mode).iconColor};
  }
`;
